<div class="sh-card-table-wrapper" [class.-sh-sticky-columns]="stickyActions && actionItems">
    @if (columns()) {
        <sh-table-head
            [columns]="columns()"
            [columnOptions]="columnOptions()"
            [availableSelect]="availableSelect()"
            [availableDragAndDrop]="availableDragAndDrop()"
            [availableActionItems]="!!actionItems"
            [itemsSelectedLabelKey]="itemsSelectedLabelKey"
            [noItemsSelectedLabelKey]="noItemsSelectedLabelKey"
            [canBatchSelect]="canBatchSelect"
            [selectedItemsCount]="selectedItemsCount"
            [selectedPageItemsCount]="selectedPageItems"
            [totalPageItemsCount]="rowElements?.length ?? 0"
            [isInitialBulk]="isInitialBulk"
            [allowSort]="allowSort()"
            [currentSort]="sortInfo"
            [contextActionGroup]="contextActionGroup"
            [hideColumnHeaders]="hideColumnHeaders"
            (selectionChanged)="onSelectionChanged($event)"
            (sortInfoChanged)="onSortInfoChanged($event)"
            (columnSelectionChanged)="onColumnSelectionChanged($event)"
            (drop)="onParentDrop($event)"
            (dragover)="onParentDragOver($event)"
            (dragleave)="onParentDragLeave($event)"
        >
            <tbody #tbody dndDropzone dndEffectAllowed="move" (dndDrop)="onDrop($event)">
                <tr id="generic-list-loading-row" *ngIf="loading$ | async">
                    <td style="width: 2000vw" [attr.colspan]="columnCount()">{{ loadingMsg }}</td>
                </tr>

                <tr id="generic-list-error-row" *ngIf="hasError && !(loading$ | async)" class="sh-card-table__row--error">
                    <td style="width: 2000vw" [attr.colspan]="columnCount()">{{ loadingFailedMsg }}</td>
                </tr>

                <ng-container *ngIf="!hasError && rowElements && !(loading$ | async)">
                    <tr id="generic-list-empty-row" *ngIf="rowElements?.length === 0" class="sh-card-table__row--update">
                        <td style="width: 2000vw" [attr.colspan]="columnCount()">{{ emptyListMsg }}</td>
                    </tr>
                    <ng-container *ngFor="let rowElement of rowElements; let rowIndex = index; trackBy: trackByFunction">
                        @defer (when autoRefresh; on viewport; prefetch on idle) {
                            <tr
                                *ngIf="{ selected: isRowSelected(rowElement), highlighted: isRowHighlighted(rowElement) } as data"
                                [class.sh-card-table__row--active]="isRowActive(rowElement)"
                                [class.sh-card-table__row--selected]="data.selected || data.highlighted"
                                [class.-sh-actionable]="areItemsClickable"
                                [draggable]="availableDragAndDrop() && !disableDragAndDrop"
                                [dndDraggingClass]="'sh-card-table__row--dragging'"
                                [dndDisableIf]="!availableDragAndDrop() || disableDragAndDrop"
                                [dndDraggable]="rowElement"
                                [dndEffectAllowed]="'move'"
                                (dndStart)="onDragStart(rowElement)"
                                (dndCanceled)="onDragCanceled()"
                                (click)="onRowClicked($event, rowElement)"
                                (keydown.enter)="onRowClicked($event, rowElement)"
                                (dragenter)="onDrag($event)"
                                (dragleave)="onDrag($event)"
                                (dragend)="onDrag($event)"
                            >
                                <td
                                    *ngIf="availableDragAndDrop()"
                                    [ngClass]="disableDragAndDrop ? 'sh-card-table__col--draggable-icon--disabled' : 'sh-card-table__col--draggable-icon'"
                                    dndHandle
                                    [title]="dragAndDropTooltip"
                                >
                                    <svg sh-icon name="draggable"></svg>
                                </td>
                                <td *ngIf="availableSelect()" class="sh-card-table__col--small">
                                    <input
                                        class="sh-checkbox"
                                        type="checkbox"
                                        [checked]="data.selected"
                                        [disabled]="disableSelect"
                                        [title]="disableSelect ? disableSelectMessage : ''"
                                        (click)="onSelectRow($event, rowElement)"
                                        (keyup.enter)="onSelectRow($event, rowElement)"
                                    />
                                </td>

                                <ng-container *ngFor="let columnDefinition of columns(); let columnIndex = index">
                                    <td [width]="columnDefinition.width" [id]="columnDefinition.toString()">
                                        <sh-generic-cell
                                            [cell]="columnDefinition.mapper(rowElement)"
                                            (cellEvent)="onCellEvent($event, rowElement)"
                                        ></sh-generic-cell>
                                    </td>
                                </ng-container>

                                @if (actionItems) {
                                    <td [class.sh-sticky-col--end]="stickyActions" class="sh-card-table__col--small">
                                        <sh-action-group
                                            *ngIf="actionItems[rowIndex] as group"
                                            [actionGroup]="group"
                                            [inOverflownContainer]="true"
                                        ></sh-action-group>
                                    </td>
                                }
                            </tr>
                        } @placeholder {
                            <tr class="sh-card-table__row--placeholder loading-placeholder">
                                <td [attr.colspan]="columnCount()"></td>
                            </tr>
                        }
                    </ng-container>
                </ng-container>
                <tr id="dnd-placeholder" class="sh-card-table__row--placeholder" dndPlaceholderRef>
                    <td *ngIf="availableDragAndDrop()" class="sh-card-table__col--draggable-icon"></td>
                    <td [attr.colspan]="columnCount()"></td>
                </tr>
            </tbody>
        </sh-table-head>
    }
</div>
